import { t } from "@lingui/core/macro";
import type { WithChildren } from "@regrello/core-utils";
import { RegrelloTypography } from "@regrello/ui-core";
import { REGRELLO_PRIVACY_POLICY_URL } from "../../../../constants/globalConstants";
import { RegrelloCopyright } from "../../../../ui2/shared/components/copyright/RegrelloCopyright";

export function UnauthenticatedPageLayout({ children }: WithChildren) {
  return (
    <main className="flex flex-col w-full h-full">
      <section className="flex grow items-center justify-center">{children}</section>
      <footer className="flex justify-center p-4">
        <RegrelloTypography className="text-center flex justify-center" variant="body-xs">
          <a className="text-textDefault font-normal text-xs mr-6" href={REGRELLO_PRIVACY_POLICY_URL}>
            {t`Privacy Policy`}
          </a>
          <RegrelloCopyright />
        </RegrelloTypography>
      </footer>
    </main>
  );
}
